export enum AccessManagementServiceType {
  AppleWallet = 'AppleWallet',
  GoogleWallet = 'GoogleWallet',
  BLE = 'BLE',
}
